import { UiEventType } from '@enums/game-events.enum';
import { ActionInfo } from '@models/game-config.interface';
import Phaser from 'phaser';
import { NodeVisualState } from '@enums/node-states.enum';
import { NodeView } from '@models/nodes';
import {
  CHECKPOINT_NODE_WIDTH,
  CHECKPOINT_NODE_HEIGHT,
} from '@constants/common.const';
import { BaseNodeStrategy } from './BaseNodeStrategy';
import { StateChangeHelpers, NodeEventContext } from './NodeVisualStrategy';

/**
 * Strategy for Finish node type.
 * Uses larger size (128x128), custom texture, no outline.
 */
export class FinishNodeStrategy extends BaseNodeStrategy {
  getSize(): { width: number; height: number } {
    return { width: CHECKPOINT_NODE_WIDTH, height: CHECKPOINT_NODE_HEIGHT };
  }

  getTextureForState(_state: NodeVisualState, _scene: Phaser.Scene): void {
    return;
  }

  getDefaultNodeImage(
    scene: Phaser.Scene,
    action: ActionInfo,
  ): {
    sprite: Phaser.GameObjects.Image;
    scaleX: number;
    scaleY: number;
  } {
    const textureKey = action.uuid;
    const { width, height } = this.getSize();
    const tex = scene.textures
      .get(textureKey)
      .getSourceImage() as HTMLImageElement;
    const scaleX = width / tex.width;
    const scaleY = height / tex.height;
    const sprite = scene.add.image(0, 0, textureKey);
    sprite.setOrigin(0.5).setScale(scaleX, scaleY);
    // checkpoint image should be black and white on start
    const fx = sprite.preFX?.addColorMatrix();
    if (fx) {
      fx.blackWhite(true);
    }
    return {
      sprite,
      scaleX,
      scaleY,
    };
  }

  supportsOutline(): boolean {
    return false;
  }

  onStateChange(
    _view: NodeView,
    _state: NodeVisualState,
    _helpers: StateChangeHelpers,
  ): void {}

  onLanded(context: NodeEventContext, view: NodeView): void {
    this.playAnimation(context, view);
  }

  private playAnimation(context: NodeEventContext, view: NodeView): void {
    const { scene } = context;
    // remove black and white filter
    view.sprite.preFX?.clear();
    scene.events.emit(UiEventType.FINISH_GAME);
  }
}
